import React, { useState } from "react";
import { Table, Row, Col, Form, DatePicker, Input, Button, Typography, } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { reportService } from "../../../services";
import { handlePDFDownload, handlePrint, exportToExcel } from "../../../utils/printing";

const { Title } = Typography;

function CollectionAmount() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [collection, setCollection] = useState([]);
  const [allcollection, setAllCollection] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [payload, setPayload] = useState(null);

  const columns = [
    {
      title: "id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Receipt Number",
      dataIndex: "Receipt Number",
      key: "Receipt Number",
    },
    {
      title: "User Name",
      dataIndex: "User Name",
      key: "User Name",
    },
    {
      title: "Receipt Date",
      dataIndex: "Receipt Date",
      key: "Receipt Date",
    },

    {
      title: "Actual Collection Date",
      dataIndex: "Actual Collection Date",
      key: "Actual Collection Date",
    },
    {
      title: "Payment Mode",
      dataIndex: "Payment Mode",
      key: "Payment Mode",
    },

    {
      title: "Invoice#",
      dataIndex: "Invoice #",
      key: "Invoice #",
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      key: "Amount",
    },
  ];

  const onFinish = (values) => {
    setPayload({
      from_date: values.from_date.format("YYYY-MM-DD"),
      to_date: values.to_date.format("YYYY-MM-DD"),
    });
    const payload = {
      from_date: values.from_date.format("YYYY-MM-DD"),
      to_date: values.to_date.format("YYYY-MM-DD"),
    };
    initialize(pagination.current, pagination.pageSize, payload);
  };

  const initialize = async (
    page = 1,
    pageSize = pagination.pageSize,
    payload = null
  ) => {
    setLoading(true);
    const { success, data } = await reportService.CollectionAmount(
      page,
      payload
    );
    setLoading(false);
    if (success) {
      setCollection(data);
      setPagination((prev) => ({
        ...prev,
        total: data.pagination.total,
        current: page,
        pageSize,
      }));
      getAll();
    }
    setLoading(false);
  };

  const getAll = async () => {
    const { data } = await reportService.CollectionAmount(1, payload, true);
    setAllCollection(data.data);
  }


  return (
    <>
      <Title level={5}>Collection Amount</Title>

      <Form
        requiredMark={false}
        layout="vertical"
        form={form}
        onFinish={onFinish}
      >
        <Row gutter={24} className="mt-8">
          <Col span={8}>
            <Form.Item label="From date" name="from_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="To date" name="to_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>

          <Col span={2}>
            <Form.Item label={<></>}>
              <Button type="primary" htmlType="submit">
                <SearchOutlined style={{ fontSize: "15px" }} />
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Col span={24}>
        <Row
          gutter={0}
          style={{
            padding: "8px",
            marginTop: "2px",
            background: "#F2F2F7",
            borderRadius: "4px",
          }}
          className="flex justify-between"
        >
          <Col span={12}>
            <div className="flex">
              <Button onClick={() => handlePrint(allcollection, columns, "Collection Amount Report")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }} >
                <span style={{ fontWeight: "bold", padding: "3px" }}>Print</span>
              </Button>

              {/* <Button type='text' size='small' style={{ padding: '4px' }}>
                <FaRegFile style={{ fontSize: "20px" }} />
              </Button> */}

              <Button onClick={() => exportToExcel(allcollection, "Collection_amount.xlsx")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>Excel</span>
              </Button>

              <Button onClick={() => handlePDFDownload(allcollection, columns, "Collection Amount Report", false)} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>PDF</span>
              </Button>

              {/* <Button type='text' size='small' style={{ padding: '4px' }}>
                <RiFileCopyLine style={{ fontSize: "24px" }} />
              </Button> */}
            </div>
          </Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <Input
              placeholder="Search"
              prefix={<SearchOutlined />}
              className="w-auto lg:w-2/5"
            />
          </Col>
        </Row>
        <div id="printable-table">
          <Table
            columns={columns}
            scroll={{ x: "max-content" }}
            loading={loading}
            pagination={{
              current: pagination.current,
              total: pagination.total,
              pageSize: pagination.pageSize,
              onChange: (page) => initialize(page, pagination.pageSize, payload),
              showSizeChanger: false,
            }}
            dataSource={collection.data}
            style={{ marginTop: "10px" }}
            summary={() => (
              <Table.Summary.Row className="font-bold">
                <Table.Summary.Cell
                  colSpan={columns.length - 2}
                ></Table.Summary.Cell>
                <Table.Summary.Cell>Total Amount Collected:</Table.Summary.Cell>
                <Table.Summary.Cell colSpan={2}>
                  ${parseFloat(collection?.totalAmount || 0).toFixed(2)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            )}
          />
        </div>
      </Col>
    </>
  );
}

export default CollectionAmount;
